<template>
  <div v-if="task">
    <h1>{{ task.referenceTaskName }}</h1>
    <DataList :data="task" :attributes="attributes" />
    <JsonEditor v-model="taskResult" />
    <button @click="updateTaskResult(taskResult)">Save</button>
    <button @click="cancelUpdateTaskResult">Return to Task List</button>
    <button @click="cancelUpdateTaskResultToWorkflow">
      Return to workflow
    </button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'TaskResultEdit',
  props: ['taskId'],
  data() {
    return {
      attributes: [
        { name: 'taskType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'workflowType', type: 'text' },
        { name: 'workflowInstanceId', type: 'text' },
        { name: 'scheduledTime', type: 'date' },
        { name: 'queueWaitTime', type: 'duration' },
        { name: 'startTime', type: 'date' },
        { name: 'updateTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'reasonForIncompletion', type: 'text' }
      ],
      // com.netflix.conductor.common.metadata.tasks.TaskResult
      taskResult: {
        status: 'IN_PROGRESS',
        outputData: {},
        outputMessage: null,
        reasonForIncompletion: null
      }
    }
  },
  computed: mapState(['task']),
  methods: mapActions([
    'getTask',
    'updateTaskResult',
    'cancelUpdateTaskResult',
    'cancelUpdateTaskResultToWorkflow'
  ]),
  created() {
    this.getTask(this.taskId)
  },
  watch: {
    taskId: function() {
      this.getTask(this.taskId)
    }
  },
  components: {
    DataList,
    JsonEditor
  }
}
</script>
